/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ArtifactRoutingRuleResponse } from '../models/artifact-routing-rule-response';
import { ArtifactRoutingRuleRequest } from '../models/artifact-routing-rule-request';
import { TestRuleResponse } from '../models/test-rule-response';
import { Criterion } from '../models/criterion';

/**
 * Ui Artifact Routing Rule Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiArtifactRoutingRuleControllerService extends __BaseService {
  static readonly getAllArtifactRoutingRulesUsingGETPath =
    '/cc-ui/v1/artifact-routing-rule';
  static readonly addArtifactRoutingRuleUsingPOSTPath =
    '/cc-ui/v1/artifact-routing-rule';
  static readonly updateArtifactRoutingRuleUsingPUTPath =
    '/cc-ui/v1/artifact-routing-rule';
  static readonly getAllOperatorsUsingGETPath =
    '/cc-ui/v1/artifact-routing-rule/operators';
  static readonly testRuleForBranchNameUsingPOSTPath =
    '/cc-ui/v1/artifact-routing-rule/test';
  static readonly getArtifactRoutingRuleUsingGETPath =
    '/cc-ui/v1/artifact-routing-rule/{ruleId}';
  static readonly deleteArtifactRoutingRuleUsingDELETEPath =
    '/cc-ui/v1/artifact-routing-rule/{ruleId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllArtifactRoutingRules
   * @param params The `UiArtifactRoutingRuleControllerService.GetAllArtifactRoutingRulesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `registrationType`: registrationType
   *
   * @return OK
   */
  getAllArtifactRoutingRulesUsingGETResponse(
    params: UiArtifactRoutingRuleControllerService.GetAllArtifactRoutingRulesUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ArtifactRoutingRuleResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.stackName != null)
      __params = __params.set('stackName', params.stackName.toString());
    if (params.registrationType != null)
      __params = __params.set(
        'registrationType',
        params.registrationType.toString(),
      );
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifact-routing-rule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ArtifactRoutingRuleResponse>>;
      }),
    );
  }
  /**
   * getAllArtifactRoutingRules
   * @param params The `UiArtifactRoutingRuleControllerService.GetAllArtifactRoutingRulesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `registrationType`: registrationType
   *
   * @return OK
   */
  getAllArtifactRoutingRulesUsingGET(
    params: UiArtifactRoutingRuleControllerService.GetAllArtifactRoutingRulesUsingGETParams,
  ): __Observable<Array<ArtifactRoutingRuleResponse>> {
    return this.getAllArtifactRoutingRulesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ArtifactRoutingRuleResponse>),
    );
  }

  /**
   * addArtifactRoutingRule
   * @param artifactRoutingRuleRequest artifactRoutingRuleRequest
   * @return OK
   */
  addArtifactRoutingRuleUsingPOSTResponse(
    artifactRoutingRuleRequest: ArtifactRoutingRuleRequest,
  ): __Observable<__StrictHttpResponse<ArtifactRoutingRuleResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRoutingRuleRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifact-routing-rule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactRoutingRuleResponse>;
      }),
    );
  }
  /**
   * addArtifactRoutingRule
   * @param artifactRoutingRuleRequest artifactRoutingRuleRequest
   * @return OK
   */
  addArtifactRoutingRuleUsingPOST(
    artifactRoutingRuleRequest: ArtifactRoutingRuleRequest,
  ): __Observable<ArtifactRoutingRuleResponse> {
    return this.addArtifactRoutingRuleUsingPOSTResponse(
      artifactRoutingRuleRequest,
    ).pipe(__map((_r) => _r.body as ArtifactRoutingRuleResponse));
  }

  /**
   * updateArtifactRoutingRule
   * @param artifactRoutingRuleRequest artifactRoutingRuleRequest
   * @return OK
   */
  updateArtifactRoutingRuleUsingPUTResponse(
    artifactRoutingRuleRequest: ArtifactRoutingRuleRequest,
  ): __Observable<__StrictHttpResponse<ArtifactRoutingRuleResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRoutingRuleRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/cc-ui/v1/artifact-routing-rule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactRoutingRuleResponse>;
      }),
    );
  }
  /**
   * updateArtifactRoutingRule
   * @param artifactRoutingRuleRequest artifactRoutingRuleRequest
   * @return OK
   */
  updateArtifactRoutingRuleUsingPUT(
    artifactRoutingRuleRequest: ArtifactRoutingRuleRequest,
  ): __Observable<ArtifactRoutingRuleResponse> {
    return this.updateArtifactRoutingRuleUsingPUTResponse(
      artifactRoutingRuleRequest,
    ).pipe(__map((_r) => _r.body as ArtifactRoutingRuleResponse));
  }

  /**
   * getAllOperators
   * @return OK
   */
  getAllOperatorsUsingGETResponse(): __Observable<
    __StrictHttpResponse<
      Array<'EQUALS' | 'STARTS_WITH' | 'ENDS_WITH' | 'CONTAINS'>
    >
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifact-routing-rule/operators`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<
          Array<'EQUALS' | 'STARTS_WITH' | 'ENDS_WITH' | 'CONTAINS'>
        >;
      }),
    );
  }
  /**
   * getAllOperators
   * @return OK
   */
  getAllOperatorsUsingGET(): __Observable<
    Array<'EQUALS' | 'STARTS_WITH' | 'ENDS_WITH' | 'CONTAINS'>
  > {
    return this.getAllOperatorsUsingGETResponse().pipe(
      __map(
        (_r) =>
          _r.body as Array<'EQUALS' | 'STARTS_WITH' | 'ENDS_WITH' | 'CONTAINS'>,
      ),
    );
  }

  /**
   * testRuleForBranchName
   * @param params The `UiArtifactRoutingRuleControllerService.TestRuleForBranchNameUsingPOSTParams` containing the following parameters:
   *
   * - `metadata`: metadata
   *
   * - `criteria`: criteria
   *
   * @return OK
   */
  testRuleForBranchNameUsingPOSTResponse(
    params: UiArtifactRoutingRuleControllerService.TestRuleForBranchNameUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<TestRuleResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.metadata != null)
      __params = __params.set('metadata', params.metadata.toString());
    __body = params.criteria;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifact-routing-rule/test`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TestRuleResponse>;
      }),
    );
  }
  /**
   * testRuleForBranchName
   * @param params The `UiArtifactRoutingRuleControllerService.TestRuleForBranchNameUsingPOSTParams` containing the following parameters:
   *
   * - `metadata`: metadata
   *
   * - `criteria`: criteria
   *
   * @return OK
   */
  testRuleForBranchNameUsingPOST(
    params: UiArtifactRoutingRuleControllerService.TestRuleForBranchNameUsingPOSTParams,
  ): __Observable<TestRuleResponse> {
    return this.testRuleForBranchNameUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as TestRuleResponse),
    );
  }

  /**
   * getArtifactRoutingRule
   * @param ruleId ruleId
   * @return OK
   */
  getArtifactRoutingRuleUsingGETResponse(
    ruleId: string,
  ): __Observable<__StrictHttpResponse<ArtifactRoutingRuleResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifact-routing-rule/${encodeURIComponent(String(ruleId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactRoutingRuleResponse>;
      }),
    );
  }
  /**
   * getArtifactRoutingRule
   * @param ruleId ruleId
   * @return OK
   */
  getArtifactRoutingRuleUsingGET(
    ruleId: string,
  ): __Observable<ArtifactRoutingRuleResponse> {
    return this.getArtifactRoutingRuleUsingGETResponse(ruleId).pipe(
      __map((_r) => _r.body as ArtifactRoutingRuleResponse),
    );
  }

  /**
   * deleteArtifactRoutingRule
   * @param ruleId ruleId
   */
  deleteArtifactRoutingRuleUsingDELETEResponse(
    ruleId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/artifact-routing-rule/${encodeURIComponent(String(ruleId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteArtifactRoutingRule
   * @param ruleId ruleId
   */
  deleteArtifactRoutingRuleUsingDELETE(ruleId: string): __Observable<null> {
    return this.deleteArtifactRoutingRuleUsingDELETEResponse(ruleId).pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiArtifactRoutingRuleControllerService {
  /**
   * Parameters for getAllArtifactRoutingRulesUsingGET
   */
  export interface GetAllArtifactRoutingRulesUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * registrationType
     */
    registrationType?: string;
  }

  /**
   * Parameters for testRuleForBranchNameUsingPOST
   */
  export interface TestRuleForBranchNameUsingPOSTParams {
    /**
     * metadata
     */
    metadata: any;

    /**
     * criteria
     */
    criteria: Array<Criterion>;
  }
}

export { UiArtifactRoutingRuleControllerService };
